import React from 'react';
import { Database, Layers, Tag, Gauge, Network, Activity, CheckCircle2, AlertCircle, Rows3, Info, Clock, Snowflake, ChevronRight, X } from 'lucide-react';
import GraphCanvasShell from './GraphCanvasShell';
import LineageModal from './LineageModal';
import { getDatasourceIcon } from '../utils/configure_utils';
import RcTooltip from 'rc-tooltip';

/* ═══════════════════════════════════════════════
 *  Custom icons
 *  fill="currentColor" rather than the literal hex from the source SVGs, so the
 *  existing state cascade (#ADB5BD default, #F64E60 error, #007BFF traced) still
 *  drives them. The original 16x16 clipPath was a full-viewBox rect — it clipped
 *  nothing, and repeating its id on every row would duplicate ids across the DOM.
 * ═══════════════════════════════════════════════ */
const TaskIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <path d="M12.9401 4.94016L9.72008 1.72016C9.47341 1.4735 9.13341 1.3335 8.78008 1.3335H4.00008C3.26675 1.3335 2.67341 1.9335 2.67341 2.66683L2.66675 13.3335C2.66675 14.0668 3.26008 14.6668 3.99341 14.6668H12.0001C12.7334 14.6668 13.3334 14.0668 13.3334 13.3335V5.88683C13.3334 5.5335 13.1934 5.1935 12.9401 4.94016ZM6.82008 11.5268L5.40675 10.1135C5.14675 9.8535 5.14675 9.4335 5.40675 9.1735C5.66675 8.9135 6.08675 8.9135 6.34675 9.1735L7.28675 10.1135L9.64675 7.7535C9.90675 7.4935 10.3267 7.4935 10.5867 7.7535C10.8467 8.0135 10.8467 8.4335 10.5867 8.6935L7.76008 11.5202C7.50675 11.7868 7.08008 11.7868 6.82008 11.5268ZM9.33342 6.00016C8.96675 6.00016 8.66675 5.70016 8.66675 5.3335V2.3335L12.3334 6.00016H9.33342Z" fill="currentColor" />
    </svg>
);

const TroubleshootIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <path d="M7.33594 12.0026C6.63594 12.0026 5.98316 11.8804 5.3776 11.6359C4.77205 11.3915 4.23594 11.0582 3.76927 10.6359C3.63594 10.5137 3.57483 10.3665 3.58594 10.1943C3.59705 10.022 3.67483 9.87483 3.81927 9.7526C3.96372 9.63038 4.13038 9.57205 4.31927 9.5776C4.50816 9.58316 4.67483 9.64705 4.81927 9.76927C5.17483 10.0582 5.56094 10.2804 5.9776 10.4359C6.39427 10.5915 6.84705 10.6693 7.33594 10.6693C8.44705 10.6693 9.39149 10.2804 10.1693 9.5026C10.947 8.72483 11.3359 7.78038 11.3359 6.66927C11.3359 5.55816 10.947 4.61372 10.1693 3.83594C9.39149 3.05816 8.44705 2.66927 7.33594 2.66927C6.41372 2.66927 5.59983 2.94705 4.89427 3.5026C4.18872 4.05816 3.71927 4.76372 3.48594 5.61927C3.43038 5.80816 3.33038 5.97483 3.18594 6.11927C3.04149 6.26372 2.87483 6.33594 2.68594 6.33594C2.49705 6.33594 2.34427 6.26094 2.2276 6.11094C2.11094 5.96094 2.07483 5.79149 2.11927 5.6026C2.37483 4.38038 2.98316 3.36372 3.94427 2.5526C4.90538 1.74149 6.03594 1.33594 7.33594 1.33594C8.82483 1.33594 10.0859 1.8526 11.1193 2.88594C12.1526 3.91927 12.6693 5.18038 12.6693 6.66927C12.6693 7.29149 12.5693 7.8776 12.3693 8.4276C12.1693 8.9776 11.8915 9.48038 11.5359 9.93594L14.2026 12.6026C14.3248 12.7248 14.3859 12.8804 14.3859 13.0693C14.3859 13.2582 14.3248 13.4137 14.2026 13.5359C14.0804 13.6582 13.9248 13.7193 13.7359 13.7193C13.547 13.7193 13.3915 13.6582 13.2693 13.5359L10.6026 10.8693C10.147 11.2248 9.64427 11.5026 9.09427 11.7026C8.54427 11.9026 7.95816 12.0026 7.33594 12.0026ZM7.11927 7.56927L7.73594 5.6526C7.76927 5.56372 7.82205 5.48872 7.89427 5.4276C7.96649 5.36649 8.0526 5.33594 8.1526 5.33594H8.5526C8.64149 5.33594 8.71927 5.35816 8.78594 5.4026C8.8526 5.44705 8.90816 5.50816 8.9526 5.58594L9.83594 7.33594C9.98038 7.33594 10.0998 7.38316 10.1943 7.4776C10.2887 7.57205 10.3359 7.69149 10.3359 7.83594C10.3359 7.98038 10.2887 8.09983 10.1943 8.19427C10.0998 8.28872 9.98038 8.33594 9.83594 8.33594H9.53594C9.44705 8.33594 9.36094 8.31094 9.2776 8.26094C9.19427 8.21094 9.13038 8.14149 9.08594 8.0526L8.43594 6.76927L7.7026 9.01927C7.66927 9.11927 7.61372 9.19705 7.53594 9.2526C7.45816 9.30816 7.36927 9.33594 7.26927 9.33594H6.96927C6.86927 9.33594 6.7776 9.30538 6.69427 9.24427C6.61094 9.18316 6.5526 9.1026 6.51927 9.0026L5.56927 5.86927L4.81927 8.0026C4.78594 8.1026 4.7276 8.18316 4.64427 8.24427C4.56094 8.30538 4.46372 8.33594 4.3526 8.33594H1.83594C1.69149 8.33594 1.57205 8.28872 1.4776 8.19427C1.38316 8.09983 1.33594 7.98038 1.33594 7.83594C1.33594 7.69149 1.38316 7.57205 1.4776 7.4776C1.57205 7.38316 1.69149 7.33594 1.83594 7.33594H4.0026L4.98594 4.48594C5.01927 4.38594 5.0776 4.30816 5.16094 4.2526C5.24427 4.19705 5.33594 4.16927 5.43594 4.16927H5.7526C5.86372 4.16927 5.95816 4.2026 6.03594 4.26927C6.11372 4.33594 6.16927 4.41927 6.2026 4.51927L7.11927 7.56927Z" fill="currentColor" />
    </svg>
);

const FeatureSearchIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <path d="M12.8693 5.93594L15.0026 8.06927L14.0693 9.0026L11.9359 6.86927C11.7026 7.0026 11.4526 7.11371 11.1859 7.2026C10.9193 7.29149 10.6359 7.33594 10.3359 7.33594C9.5026 7.33594 8.79427 7.04427 8.21094 6.46094C7.6276 5.8776 7.33594 5.16927 7.33594 4.33594C7.33594 3.5026 7.6276 2.79427 8.21094 2.21094C8.79427 1.6276 9.5026 1.33594 10.3359 1.33594C11.1693 1.33594 11.8776 1.6276 12.4609 2.21094C13.0443 2.79427 13.3359 3.5026 13.3359 4.33594C13.3359 4.63594 13.2915 4.91927 13.2026 5.18594C13.1137 5.4526 13.0026 5.7026 12.8693 5.93594ZM10.3359 6.0026C10.8026 6.0026 11.197 5.84149 11.5193 5.51927C11.8415 5.19705 12.0026 4.8026 12.0026 4.33594C12.0026 3.86927 11.8415 3.47483 11.5193 3.1526C11.197 2.83038 10.8026 2.66927 10.3359 2.66927C9.86927 2.66927 9.47483 2.83038 9.1526 3.1526C8.83038 3.47483 8.66927 3.86927 8.66927 4.33594C8.66927 4.8026 8.83038 5.19705 9.1526 5.51927C9.47483 5.84149 9.86927 6.0026 10.3359 6.0026ZM11.6359 8.46927L13.3359 10.1693V13.3359C13.3359 13.7026 13.2054 14.0165 12.9443 14.2776C12.6832 14.5387 12.3693 14.6693 12.0026 14.6693H2.66927C2.3026 14.6693 1.98872 14.5387 1.7276 14.2776C1.46649 14.0165 1.33594 13.7026 1.33594 13.3359V4.0026C1.33594 3.63594 1.46649 3.32205 1.7276 3.06094C1.98872 2.79983 2.3026 2.66927 2.66927 2.66927H6.33594C6.21372 2.94705 6.13038 3.23316 6.08594 3.5276C6.04149 3.82205 6.01927 4.11372 6.01927 4.4026C6.01927 5.61371 6.44705 6.62483 7.3026 7.43594C8.15816 8.24705 9.17483 8.6526 10.3526 8.6526C10.5637 8.6526 10.7748 8.63871 10.9859 8.61094C11.197 8.58316 11.4137 8.53594 11.6359 8.46927Z" fill="currentColor"/>
    </svg>
);

const KpiIcon = (props) => (
    <svg className='tw-inline-block' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
        <path d="M14.7695 3.375C15.1483 3.37508 15.469 3.50613 15.7314 3.76855C15.9939 4.03098 16.1249 4.35174 16.125 4.73047V13.2695C16.1249 13.6483 15.9939 13.969 15.7314 14.2314C15.469 14.4939 15.1483 14.6249 14.7695 14.625H3.23047C2.85174 14.6249 2.53098 14.4939 2.26855 14.2314C2.00613 13.969 1.87508 13.6483 1.875 13.2695V4.73047C1.87508 4.35174 2.00613 4.03098 2.26855 3.76855C2.53098 3.50613 2.85174 3.37508 3.23047 3.375H14.7695ZM4.5 6.75V10.8281H5.49316V9.02734L6.86426 10.8281H8.0791L6.44043 8.74902L8.02051 6.75H6.85254L5.49316 8.53906V6.75H4.5ZM8.55078 10.8281H9.54395V9.36426H10.1602C11.1999 9.36426 11.659 8.73726 11.6592 8.06348C11.6592 7.314 11.1595 6.75 10.1602 6.75H8.55078V10.8281ZM12.1768 10.8281H13.1699V6.75H12.1768V10.8281ZM10.085 7.55176C10.4799 7.55183 10.6484 7.7498 10.6484 8.06348C10.6483 8.3769 10.4797 8.57414 10.085 8.57422H9.54395V7.55176H10.085Z" fill="currentColor" />
    </svg>
);

/* ═══════════════════════════════════════════════
 *  AttrItem – ellipsis-only rc-tooltip on truncated text
 * ═══════════════════════════════════════════════ */
class AttrItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isTruncated: false };
        this.textRef = React.createRef();
    }

    componentDidMount() {
        this.mounted = true;
        this.checkTruncation();
        // Re-measure once layout/webfonts settle — the first read can miss
        // items that sit right on the truncation boundary
        this.raf = requestAnimationFrame(() => this.checkTruncation());
    }

    componentDidUpdate(prevProps) {
        if (prevProps.text !== this.props.text) {
            this.checkTruncation();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.raf) cancelAnimationFrame(this.raf);
    }

    checkTruncation() {
        const el = this.textRef.current;
        if (!el || this.mounted === false) return;
        const isTruncated = el.scrollWidth > el.offsetWidth;
        if (isTruncated !== this.state.isTruncated) {
            this.setState({ isTruncated });
        }
    }

    render() {
        const { icon, text, className = '', bold = false, onOpenDetails, onTrace, isTraced = false, isError = false } = this.props;
        const { isTruncated } = this.state;

     
        const textSpan = (
            <span
                ref={this.textRef}
                className="attr-text"
                style={{
                    // lineHeight pinned so the row stays 24px (18px text box + 3px
                    // padding top/bottom) — getCardHeight() sizes cards off that 24
                    fontSize: '12px',
                    lineHeight: '18px',
                    fontWeight: bold ? 600 : 500,
                    // Long snake_case names overflow the fixed card width at this size
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    wordBreak: 'normal',
                    minWidth: 0,
                    flex: 1,
                    display: 'block'
                }}
            >
                {text}
            </span>
        );

        const content = (
            <div className={`c-item c-item-link ${isTraced ? 'is-traced' : ''} ${isError ? 'is-error' : ''} ${className}`} style={{ cursor: 'default' }}>
                <span className="fi">{icon}</span>
                {textSpan}
                {onOpenDetails && (
                    <button
                        type="button"
                        className="attr-act attr-open"
                        title="Open details"
                        aria-label={`Open details for ${text}`}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenDetails(text); }}
                    >
                        <FeatureSearchIcon />
                    </button>
                )}
                {onTrace && (
                    <button
                        type="button"
                        className={`attr-act attr-trace ${isTraced ? 'on' : ''}`}
                        title={isTraced ? 'Clear lineage' : 'Show linked cards'}
                        aria-label={`Show cards linked to ${text}`}
                        aria-pressed={isTraced}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onTrace(text); }}
                    >
                        <TroubleshootIcon />
                    </button>
                )}
            </div>
        );

        if (!isTruncated) return content;

        return (
            <RcTooltip
                placement="top"
                classNames={{ root: 'lin-attr-tip' }}
                // .lin-overlay sits at z-index 1200; the default .rc-tooltip (1070)
                // would render behind the lineage backdrop
                zIndex={1300}
                overlay={<span style={{ fontSize: '12px', wordBreak: 'break-all', maxWidth: '220px', display: 'block' }}>{text}</span>}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            >
                {content}
            </RcTooltip>
        );
    }
}

/* ═══════════════════════════════════════════════
 *  ExpandableList – dynamic expand with max-height scroll
 * ═══════════════════════════════════════════════ */
class ExpandableList extends React.Component {
    render() {
        const { items = [], renderItem, limit = 5, expanded = false, onToggle } = this.props;
        const visibleItems = expanded ? items : items.slice(0, limit);
        const remaining = items.length - limit;
        const hasMore = items.length > limit;

        return (
            <div>
                <div
                    className={expanded ? 'c-sec-scroll' : ''}
                    style={{
                        maxHeight: expanded ? '220px' : 'none',
                        overflowY: expanded ? 'auto' : 'visible',
                        paddingRight: expanded ? '4px' : '0'
                    }}
                >
                    {visibleItems.map((item, idx) => renderItem(item, idx))}
                </div>
                {hasMore && (
                    <button
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (onToggle) onToggle();
                        }}
                        style={{
                            marginLeft: '6px',
                            marginTop: '8px',
                            marginBottom: '8px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#007BFF',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0,
                            outline: 'none'
                        }}
                    >
                        {expanded ? 'Show less' : `View ${remaining} more...`}
                    </button>
                )}
            </div>
        );
    }
}

/* ═══════════════════════════════════════════════
 *  Layout constants
 * ═══════════════════════════════════════════════ */
// One standard card width for every card type
const CARD_W = 280;
// Edges rest grey. Tracing colours the connected path: red from a critical card,
// blue from any other.
const EDGE_COLOR = '#CED4DA';
const EDGE_COLOR_ACTIVE = '#3B82F6';
const EDGE_COLOR_CRITICAL = '#FB7185';
/* Row height must match the CSS exactly: 18px line box + 6px padding top/bottom.
 * The hover chip needs that 6px permanently — applying padding only on :hover
 * would resize rows under the cursor and reflow the card. */
const ROW_H = 30;
const COL_GAP = 120;
const CARD_GAP = 100;
const PAD = 40;

function getCardHeight(card, isExpanded) {
    const HEAD_H = 48;

    if (card.type === 'source') {
        const listH = isExpanded ? 220 : Math.min(card.items.length, 5) * ROW_H;
        const btnH = card.items.length > 5 ? 36 : 0;
        const secH = 30 + listH + btnH + 16;
        return HEAD_H + secH;
    }

    if (card.type === 'pipe') {
        const listH = isExpanded ? 220 : Math.min(card.tasks.length, 5) * ROW_H;
        const btnH = card.tasks.length > 5 ? 36 : 0;
        const secH = 24 + listH + btnH + 16;
        const footH = 34;
        return HEAD_H + secH + footH;
    }

    if (card.type === 'data') {
        const listH = isExpanded ? 220 : Math.min(card.attrs.length, 5) * ROW_H;
        const btnH = card.attrs.length > 5 ? 36 : 0;
        const sec1H = 24 + listH + btnH + 16;
        const sec2H = 24 + (2 * ROW_H) + 16;
        return HEAD_H + sec1H + sec2H;
    }

    if (card.type === 'kpi') {
        const sec1H = 24 + ROW_H + 8;
        const sec2H = 24 + 36 + 16;
        return HEAD_H + sec1H + sec2H;
    }

    return 240;
}

/* ═══════════════════════════════════════════════
 *  Attribute & task generators
 * ═══════════════════════════════════════════════ */
const ATTR_BASES = [
    'id','name','type','status','code','created_at','updated_at','amount','value','flag',
    'count','rate','score','level','key_hash','ref_id','description','notes','tag','label',
    'sort_index','rank','weight','priority','version','source_id','target_id','start_date',
    'end_date','duration_ms','latitude','longitude','zip_code','city','state','country',
    'region','tier','group_id','category','class_code','segment','channel','platform',
    'device_type','browser','os_version','locale','currency_code','timezone','email','phone',
    'address_line','is_active','is_deleted','is_verified','margin_pct','discount_amt',
    'tax_amt','fee_amt','cost_basis','unit_price','quantity','unit_of_measure','batch_id',
    'run_id','etl_timestamp','partition_key','schema_ver','checksum','audit_trail',
    'approval_flag','owner_id','team_id','org_id','tenant_id','env','config_key',
    'metric_name','metric_value','threshold','alert_level','resolution','confidence',
    'percentile','median_val','std_dev','variance','correlation','forecast','actual',
    'delta','pct_change','yoy_growth','mom_growth','cohort','funnel_step','conversion_rate',
    'bounce_rate','session_dur','page_views','click_count','impression_ct','ctr','cpc','roas'
];

/* Qualifier words used to build long-form attribute names. The generated
 * `${prefix}_${base}` names top out around 12-18 chars, which never overflows a
 * 270px card — so cards flagged `longForm` grow every other name past the
 * ~50-char target to exercise the ellipsis + tooltip path. */
const ATTR_QUALIFIERS = [
    'normalized', 'reconciled', 'enriched', 'validated', 'derived', 'standardized',
    'adjusted', 'weighted', 'aggregated', 'daily', 'monthly', 'rollup', 'snapshot',
    'usd', 'amount', 'value', 'ratio', 'index', 'gross', 'net'
];

const LONG_ATTR_TARGET = 50;

function lengthenAttr(name, seed) {
    let long = name;
    let n = seed;
    while (long.length < LONG_ATTR_TARGET) {
        long += `_${ATTR_QUALIFIERS[n % ATTR_QUALIFIERS.length]}`;
        n += 1;
    }
    return long;
}

function genAttrs(prefix, count, longForm = false) {
    return Array.from({ length: count }, (_, i) => {
        const base = ATTR_BASES[i % ATTR_BASES.length];
        const round = Math.floor(i / ATTR_BASES.length);
        const name = round === 0 ? `${prefix}_${base}` : `${prefix}_${base}_v${round + 1}`;
        // Every other name goes long, so a card shows truncated and untruncated rows side by side
        return longForm && i % 2 === 0 ? lengthenAttr(name, i) : name;
    });
}

const TASK_BASES = [
    'extract','load','validate','transform','dedupe','merge','enrich','aggregate','filter',
    'join','cast_types','null_check','schema_check','partition','compress','encrypt',
    'hash_pii','audit_log','notify','checkpoint','retry_failed','rollback','archive',
    'cleanup','sync_delta','publish','verify_counts','reconcile','balance_check','flag_anomaly'
];

function genTasks(prefix, count) {
    return Array.from({ length: count }, (_, i) => {
        const base = TASK_BASES[i % TASK_BASES.length];
        const round = Math.floor(i / TASK_BASES.length);
        return round === 0 ? `${prefix}_${base}` : `${prefix}_${base}_${round + 1}`;
    });
}

/* ═══════════════════════════════════════════════
 *  Status config map
 * ═══════════════════════════════════════════════ */
const STATUS_CFG = {
    success:  { Icon: CheckCircle2,  label: 'Success',     st: 'st-success',  card: '' },
    critical: { Icon: AlertCircle,   label: 'Critical',    st: 'st-critical', card: 'st-card-critical' },
    info:     { Icon: Info,          label: 'Informative', st: 'st-info',     card: '' },
};

/* ═══════════════════════════════════════════════
 *  Layout engine
 * ═══════════════════════════════════════════════ */
function computeLayout(allCards, expandedCards = {}) {
    const colMap = {};
    allCards.forEach(c => {
        if (!colMap[c.col]) colMap[c.col] = [];
        colMap[c.col].push(c);
    });

    const numCols = Math.max(...Object.keys(colMap).map(Number)) + 1;

    /* Pass 1 — collapsed baseline. Vertical centering is derived from this and
     * never from the live heights: centering off live heights meant expanding one
     * card grew the canvas, which re-centered every other column, so the whole
     * graph jumped. Fixed offsets confine an expansion to its own column. */
    let baseMaxBottom = 0;
    const baseColHeights = [];
    for (let ci = 0; ci < numCols; ci++) {
        const colCards = colMap[ci] || [];
        let y = PAD;
        let colH = 0;
        colCards.forEach((card, i) => {
            const h = getCardHeight(card, false);
            colH += h + (i > 0 ? CARD_GAP : 0);
            y += h + CARD_GAP;
        });
        baseMaxBottom = Math.max(baseMaxBottom, y);
        baseColHeights.push(colH);
    }
    const baseCanvasH = Math.max(800, baseMaxBottom + PAD);
    const colOffsets = baseColHeights.map(colH =>
        colH > 0 ? Math.max(0, (baseCanvasH - colH) / 2 - PAD) : 0
    );

    /* Pass 2 — real heights, laid out from the fixed offsets */
    let x = PAD;
    const positions = [];
    let maxBottom = 0;

    for (let ci = 0; ci < numCols; ci++) {
        const colCards = colMap[ci] || [];
        const colPositions = [];
        let y = PAD + colOffsets[ci];

        for (let i = 0; i < colCards.length; i++) {
            const card = colCards[i];
            const isExp = !!expandedCards[card.id];
            const h = getCardHeight(card, isExp);
            const w = CARD_W;
            colPositions.push({ id: card.id, x, y, w, h });
            y += h + CARD_GAP;
        }

        maxBottom = Math.max(maxBottom, y);
        positions.push(colPositions);
        x += CARD_W + COL_GAP;
    }

    const canvasW = x + PAD;
    // Only ever grows to fit an expansion — never shrinks below the stable baseline
    const canvasH = Math.max(baseCanvasH, maxBottom + PAD);

    const posMap = {};
    for (let ci = 0; ci < positions.length; ci++) {
        for (let ri = 0; ri < positions[ci].length; ri++) {
            const p = positions[ci][ri];
            posMap[p.id] = p;
        }
    }

    return { positions, posMap, canvasW, canvasH };
}

/* Straight run-in before the target card. An SVG arrowhead is a rigid triangle
 * aligned to the tangent at the path's end point; the curve below is only truly
 * horizontal AT that point, so the ~17px the marker occupies going back along the
 * path still bends away from it and the head reads as a detached shape. Landing
 * flat for longer than the marker makes the two merge into one line.
 * Must exceed marker length = markerWidth(6) x (8/10 viewBox) x strokeWidth(3.5) = 16.8px. */
const ARROW_LANDING = 22;

function bezier(from, to) {
    const x1 = from.x + from.w;
    const y1 = from.y + from.h / 2;
    const x2 = to.x;
    const y2 = to.y + to.h / 2;
    const bx = Math.max(x1, x2 - ARROW_LANDING);
    const cx = (x1 + bx) / 2;
    return `M${x1} ${y1} C${cx} ${y1},${cx} ${y2},${bx} ${y2} L${x2} ${y2}`;
}

const SOURCE_DATASETS = [
    'pos_transactions','customer_master','product_catalog','orders_stream','store_inventory',
    'payment_methods','promotions_fact','user_sessions','shipping_rates','tax_jurisdictions',
    'refund_logs','coupon_redemptions','currency_rates','supplier_orders','warehouse_bins',
    'return_reasons','audit_events','device_logs','pos_terminal_logs','register_shifts',
    'cashier_logs','receipt_archive','scanner_events','payment_gateway','drawer_balances',
    'discount_overrides','price_lookups','manager_approvals','offline_queue','tax_exemptions',
    'crm_leads','crm_opportunities','account_contacts','support_tickets','email_campaigns',
    'sales_reps','quota_targets','contract_revisions','billing_schedules','churn_surveys',
    'call_transcripts','demo_requests','partner_referrals','iot_temperature','iot_humidity',
    'iot_pressure','iot_vibration','iot_power_usage','social_posts','social_comments',
    'social_reactions','social_shares','review_ratings','review_text','review_images',
    'review_responses','geo_locations','geo_boundaries','geo_poi_data','geo_demographics'
];

/* 50 cards over 13 columns (max 4 per column) — a wide, shallow graph rather
 * than a deep one. A single source panel feeds the whole chain. */
function buildCards() {
    let id = 0;
    const c = [];
    /* On a critical card only some rows are the actual failures. Deterministic
     * (every 3rd from index 1) so the flagged rows never shuffle between renders,
     * and so at least two land inside the 5 visible before "View more". */
    const errorRows = (names, status) =>
        status === 'critical' ? new Set(names.filter((_, i) => i % 3 === 1)) : null;

    const pipe = (col, name, status, engine, prefix, n, rows) => {
        const tasks = genTasks(prefix, n);
        c.push({ id: id++, col, type: 'pipe', name, status, engine, tasks, rows, errorRows: errorRows(tasks, status) });
    };
    const data = (col, name, status, store, prefix, n, rows, freshness, longForm = false) => {
        const attrs = genAttrs(prefix, n, longForm);
        c.push({ id: id++, col, type: 'data', name, status, store, attrs, rows, freshness, errorRows: errorRows(attrs, status) });
    };

    c.push({ id: id++, col: 0, type: 'source', name: 'Enterprise Data Lake', items: SOURCE_DATASETS });

    pipe(1, 'pos_ingest_pipeline',   'success', 'ADF',      'pos',    15, '1.2M');
    pipe(1, 'crm_sync_pipeline',     'success', 'Glue', 'crm',    12, '320K');
    pipe(1, 'web_clicks_ingest',     'success', 'Composer',    'web',     9, '4.5M');
    pipe(1, 'erp_financial_ingest',  'critical','Airflow',  'erp',     8, '150K');

    data(2, 'pos_transactions_raw',  'success', 'Snowflake',     'txn',  120, '1.2M', '10m', true);
    data(2, 'crm_contacts_raw',      'success', 'Snowflake',     'crm',  100, '320K', '1h');
    data(2, 'web_events_raw',        'info',    'S3 Parquet',    'evt',   90, '4.5M', '5m');
    data(2, 'erp_general_ledger',    'critical','Snowflake',     'gl',    85, '150K', '6h',  true);

    pipe(3, 'iot_sensor_stream',     'success', 'Glue',    'iot',    11, '8.2M');
    pipe(3, 'social_media_feed',     'info',    'Azure',   'social',  7, '2.1M');
    pipe(3, 'log_analytics_ingest',  'success', 'Composer', 'log',    10, '6.5M');
    pipe(3, 'billing_ingest',        'success', 'Airflow',  'bill',    9, '410K');

    data(4, 'iot_telemetry_raw',     'success', 'Delta Lake',    'iot',  110, '8.2M', '1m');
    data(4, 'log_events_raw',        'success', 'Elasticsearch', 'log',   95, '6.5M', '2m');
    data(4, 'store_catalog_raw',     'success', 'Postgres',      'cat',   75, '85K',  '24h');
    data(4, 'billing_invoices_raw',  'critical','Snowflake',     'bill', 105, '410K', '2h',  true);

    pipe(5, 'enrich_pipeline',         'success', 'dbt',     'enrich', 15, '1.2M');
    pipe(5, 'customer_identity_stitch','success', 'Glue',   'stitch', 10, '480K');
    pipe(5, 'ledger_reconciliation',   'critical','Airflow', 'ledger',  8, '150K');
    pipe(5, 'inventory_balance_calc',  'success', 'dbt',     'inv',     7, '85K');

    data(6, 'customer_master',       'critical','Snowflake', 'cust', 150, '480K', '15m', true);
    data(6, 'sales_fact_table',      'success', 'Snowflake', 'sale', 130, '1.2M', '10m');
    data(6, 'inventory_snapshot',    'success', 'Snowflake', 'inv',   85, '85K',  '1h');
    data(6, 'billing_fact',          'critical','Snowflake', 'blf',  125, '410K', '2h',  true);

    pipe(7, 'session_attribution',   'success', 'Glue',     'sess',  12, '4.5M');
    pipe(7, 'anomaly_detection',     'success', 'Airflow',    'anom',   9, '1.8M');
    pipe(7, 'sentiment_analysis',    'success', 'MWAA', 'sent',   6, '450K');
    pipe(7, 'margin_calculator',     'success', 'dbt',       'marg',  10, '92K');

    data(8, 'revenue_daily_agg',     'info',    'Snowflake', 'rev',  140, '92K',  '1h');
    data(8, 'session_journey',       'success', 'BigQuery',  'sess', 110, '3.2M', '15m');
    data(8, 'product_performance',   'success', 'Snowflake', 'prod', 120, '250K', '30m');
    data(8, 'financial_monthly_mart','success', 'Snowflake', 'fin',   95, '12K',  '12h');

    pipe(9, 'revenue_agg_pipeline',  'success', 'Airflow',    'revagg', 12, '92K');
    pipe(9, 'forecast_pipeline',     'success', 'MWAA',  'fcast',  10, '45K');
    pipe(9, 'compliance_reporting',  'success', 'Airflow',    'comp',    7, '8K');
    pipe(9, 'supply_chain_optimizer','critical','Airflow',    'supply', 11, '65K');

    data(10, 'revenue_cube',         'success', 'Snowflake', 'rcube', 100, '92K',  '30m');
    data(10, 'customer_360',         'success', 'Snowflake', 'c360',  150, '480K', '1h');
    data(10, 'supply_chain_metrics', 'success', 'Redshift',  'scm',    90, '65K',  '2h');
    data(10, 'risk_compliance_mart', 'critical','Snowflake', 'risk',  110, '25K',  '6h',  true);

    pipe(11, 'powerbi_publish',      'success', 'ADF',  'pbi',   6, '200K');
    pipe(11, 'tableau_sync',         'success', 'Composer',  'tab',   5, '150K');
    pipe(11, 'finance_dash_sync',    'critical','ADF',  'findash', 7, '92K');

    data(12, 'marketing_roi',        'success', 'BigQuery',   'mroi',  80, '35K',  '4h');
    data(12, 'churn_prediction',     'success', 'Databricks', 'churn', 95, '480K', '6h');
    data(12, 'margin_analysis',      'critical','Snowflake',  'mgn',  115, '92K',  '1h',  true);

    c.push({ id: id++, col: 13, type: 'kpi', name: 'Total Revenue',           attr: 'transaction_amount_normalized_reconciled_usd_gross', formula: 'SUM(transaction_amount)' });
    c.push({ id: id++, col: 13, type: 'kpi', name: 'Customer Retention Rate', attr: 'retention_rate',   formula: 'COUNT(returning) / COUNT(all) x 100' });
    c.push({ id: id++, col: 13, type: 'kpi', name: 'Gross Margin %',          attr: 'gross_margin_pct', formula: '(revenue - cogs) / revenue x 100' });

    return c;
}

/* Edges are derived from the column structure rather than hand-listed. Hand-listed
 * ids silently rewire the graph whenever a card is inserted, and let same-column
 * pairs slip in — those get drawn right-edge-to-left-edge and render as garbage.
 * Generating guarantees every edge is adjacent-column and forward by construction. */
function buildEdges(cards) {
    const byCol = {};
    cards.forEach(c => { (byCol[c.col] = byCol[c.col] || []).push(c); });
    const maxCol = Math.max(...cards.map(c => c.col));
    const pairs = [];
    const seen = new Set();
    const add = (f, t) => {
        const k = `${f}-${t}`;
        if (!seen.has(k)) { seen.add(k); pairs.push([f, t]); }
    };

    for (let col = 0; col < maxCol; col++) {
        const from = byCol[col] || [];
        const to = byCol[col + 1] || [];
        if (!from.length || !to.length) continue;

        // each card fans out to two in the next column
        from.forEach((f, i) => {
            add(f.id, to[i % to.length].id);
            add(f.id, to[(i + 1) % to.length].id);
        });
        // and nothing downstream is left orphaned
        const inbound = new Set(pairs.map(([, t]) => t));
        to.forEach((t, j) => { if (!inbound.has(t.id)) add(from[j % from.length].id, t.id); });
    }
    return pairs;
}


const ALL_CARDS = buildCards();
const EDGE_PAIRS = buildEdges(ALL_CARDS);

function getLineageTrace(selectedId, edgePairs) {
    if (selectedId == null) {
        return { connectedNodes: new Set(), connectedEdges: new Set() };
    }

    const parentsMap = new Map();
    const childrenMap = new Map();

    edgePairs.forEach(([f, t]) => {
        if (!childrenMap.has(f)) childrenMap.set(f, []);
        childrenMap.get(f).push(t);

        if (!parentsMap.has(t)) parentsMap.set(t, []);
        parentsMap.get(t).push(f);
    });

    const connectedNodes = new Set([selectedId]);
    const connectedEdges = new Set();

    // Upstream BFS
    const queueUp = [selectedId];
    const visitedUp = new Set([selectedId]);
    while (queueUp.length > 0) {
        const curr = queueUp.shift();
        const parents = parentsMap.get(curr) || [];
        parents.forEach(p => {
            connectedNodes.add(p);
            connectedEdges.add(`${p}-${curr}`);
            if (!visitedUp.has(p)) {
                visitedUp.add(p);
                queueUp.push(p);
            }
        });
    }

    // Downstream BFS
    const queueDown = [selectedId];
    const visitedDown = new Set([selectedId]);
    while (queueDown.length > 0) {
        const curr = queueDown.shift();
        const children = childrenMap.get(curr) || [];
        children.forEach(c => {
            connectedNodes.add(c);
            connectedEdges.add(`${curr}-${c}`);
            if (!visitedDown.has(c)) {
                visitedDown.add(c);
                queueDown.push(c);
            }
        });
    }

    return { connectedNodes, connectedEdges };
}

/* Everything reachable downstream of a card — drives the panel's Impact Analysis.
 * getLineageTrace() walks both directions; "affected" is strictly downstream. */
function getDownstreamCards(cardId, edgePairs) {
    const childrenMap = new Map();
    edgePairs.forEach(([f, t]) => {
        if (!childrenMap.has(f)) childrenMap.set(f, []);
        childrenMap.get(f).push(t);
    });

    const visited = new Set();
    const queue = [cardId];
    while (queue.length > 0) {
        const curr = queue.shift();
        (childrenMap.get(curr) || []).forEach(c => {
            if (!visited.has(c)) {
                visited.add(c);
                queue.push(c);
            }
        });
    }
    return visited;
}

/* ═══════════════════════════════════════════════
 *  AttrDetailPanel – right-side drawer for a clicked attribute
 * ═══════════════════════════════════════════════ */
class AttrDetailPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = { tab: 'jobs' };
    }

    render() {
        const { detail, onClose, onJumpToCard } = this.props;
        if (!detail) return null;

     

        const { name, card } = detail;
        // What the clicked row is, vs. what the card it lives on is
        const kindLabel = card.type === 'pipe' ? 'Task'
            : card.type === 'source' ? 'Dataset'
            : card.type === 'kpi' ? 'Mapped attribute'
            : 'Attribute';
        const originLabel = card.type === 'pipe' ? 'Pipeline'
            : card.type === 'source' ? 'Source'
            : card.type === 'kpi' ? 'KPI'
            : 'Dataset';

        const downstream = getDownstreamCards(card.id, EDGE_PAIRS);
        const affected = ALL_CARDS.filter(c => downstream.has(c.id));
        const affectedJobs = affected.filter(c => c.type === 'pipe');
        const affectedDatasets = affected.filter(c => c.type === 'data');

        const status = card.status || 'success';
        const cfg = STATUS_CFG[status] || STATUS_CFG.success;
        const showError = status === 'critical';

        const { tab } = this.state;
        const list = tab === 'jobs' ? affectedJobs : affectedDatasets;

        return (
            <div className="lin-side">
                <div className="lin-side__head">
                    <div className="lin-side__caption">
                        <span className="lin-side__kind">{kindLabel}</span>
                        <p title={name}>{card.name} / {name}</p>
                    </div>
                    <button type="button" className="lin-side__close" onClick={onClose} aria-label="Close details">
                        <X size={16} />
                    </button>
                </div>

                <div className="lin-side__body">
                    <div className="lin-side__sec">
                        <h5 className="lin-side__sec-title">Origin</h5>
                        <div className="lin-side__kv">
                            <p><label>{originLabel}:</label>
                                <span><i>{card.type === 'pipe' ? <Network size={13} /> : card.type === 'source' ? <Database size={13} /> : card.type === 'kpi' ? <Gauge size={13} /> : <Layers size={13} />}</i>{card.name}</span></p>
                            {card.store && <p><label>Store:</label><span>{card.store}</span></p>}
                            {card.engine && <p><label>Engine:</label><span>{card.engine}</span></p>}
                            {card.rows && <p><label>Rows:</label><span>{card.rows}</span></p>}
                            {card.freshness && <p><label>Freshness:</label><span>{card.freshness}</span></p>}
                            <p><label>Status:</label>
                                <span className={`lin-side__status ${cfg.st}`}><cfg.Icon size={13} /> {cfg.label}</span></p>
                        </div>
                    </div>

                    {showError && (
                        <div className="lin-side__sec">
                            <h5 className="lin-side__sec-title">Error Message</h5>
                            <pre className="lin-side__err">{JSON.stringify({
                                error: {
                                    errorCode: status === 'critical' ? 'QD_ATTR_DRIFT' : 'QD_ATTR_STALE',
                                    message: `Validation failed for "${name}"`,
                                    failureType: status === 'critical' ? 'Critical' : 'Warning',
                                    target: `${card.name}.${name}`,
                                    details: ''
                                }
                            }, null, 2)}</pre>
                        </div>
                    )}

                    <div className="lin-side__sec">
                        <h5 className="lin-side__sec-title">Impact Analysis</h5>
                        <div className="lin-side__tabs">
                            <button
                                type="button"
                                className={tab === 'jobs' ? 'on' : ''}
                                onClick={() => this.setState({ tab: 'jobs' })}
                            >
                                Affected Jobs <span className="cnt">{affectedJobs.length}</span>
                            </button>
                            <button
                                type="button"
                                className={tab === 'datasets' ? 'on' : ''}
                                onClick={() => this.setState({ tab: 'datasets' })}
                            >
                                Affected Datasets <span className="cnt">{affectedDatasets.length}</span>
                            </button>
                        </div>
                        <ul className="lin-side__affected">
                            {list.length > 0 ? list.map(c => (
                                <li key={c.id}>
                                    <button type="button" onClick={() => onJumpToCard && onJumpToCard(c.id)}>
                                        <i>{c.type === 'pipe' ? <Network size={14} /> : <Layers size={14} />}</i>
                                        <span title={c.name}>{c.name}</span>
                                        <i className="arw"><ChevronRight size={14} /></i>
                                    </button>
                                </li>
                            )) : (
                                <li className="empty">No affected {tab === 'jobs' ? 'jobs' : 'datasets'}.</li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

/* ═══════════════════════════════════════════════
 *  WorkflowStats
 * ═══════════════════════════════════════════════ */
function WorkflowStats() {
    // Derived, not hardcoded — these drifted out of sync the moment cards were added
    const count = (type) => ALL_CARDS.filter(c => c.type === type).length;
    const attributes = ALL_CARDS.reduce((sum, c) => sum + (c.attrs ? c.attrs.length : 0), 0);

    return (
        <div className="lin-stats">
            <span className="lin-stat"><span className="ic"><Database size={15} /></span> Data sources: <b>{count('source')}</b> <span className="i"><Info size={13} /></span></span>
            <span className="lin-stat"><span className="ic"><Network size={15} /></span> Pipelines: <b>{count('pipe')}</b> <span className="i"><Info size={13} /></span></span>
            <span className="lin-stat"><span className="ic"><Layers size={15} /></span> Datasets: <b>{count('data')}</b> <span className="i"><Info size={13} /></span></span>
            <span className="lin-stat"><span className="ic"><Tag size={15} /></span> Attributes: <b>{attributes.toLocaleString()}</b> <span className="i"><Info size={13} /></span></span>
            <span className="lin-stat"><span className="ic"><Gauge size={15} /></span> KPIs: <b>{count('kpi')}</b> <span className="i"><Info size={13} /></span></span>
        </div>
    );
}

/* Trace visual states. `focus` is the card whose attribute was clicked — it has to
 * clearly outrank `linked`, otherwise the origin of the trace gets lost among the
 * neighbours it lit up. Accent matches the edge colour for the same status. */
function cardStateClasses(isSelected, isConnected, isMuted, criticalTrace) {
    const accent = criticalTrace ? ' lin-accent-critical' : '';
    if (isSelected) return `lin-focus${accent}`;
    if (isConnected) return `lin-linked${accent}`;
    if (isMuted) return 'lin-muted';
    return '';
}

/* ═══════════════════════════════════════════════
 *  Card render helpers
 * ═══════════════════════════════════════════════ */
function renderSourceCard(card, pos, isExpanded, onToggle, cardStateClass, actions = {}) {
    const { onOpenDetails, onTrace, tracedKey } = actions;

    const sourceIcon = getDatasourceIcon('snowflake') || <Snowflake size={18} className="tw-text-sky-500" />;

    return (
        <div
            key={`card-${card.id}`}
            className={`qd-data-lineage-card card ds ${cardStateClass}`}
            style={{ left: pos.x, top: pos.y, width: pos.w, height: pos.h, position: 'absolute' }}
        >
            <div className="qd-data-lineage-card__type-tab c-type-tab c-type-tab--source">Data Source</div>
            <div className="c-head">
                <span className="c-ico tw-inline-flex tw-items-center tw-justify-center">{sourceIcon}</span>
                <div className="c-head-info">
                    <span className="c-name" title={card.name}>{card.name}</span>
                </div>
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Raw datasets ({card.items.length})</div>
                <ExpandableList items={card.items} limit={5} expanded={isExpanded} onToggle={onToggle} renderItem={(item, idx) => (
                    <AttrItem key={idx} icon={<Layers size={16} />} text={item} onOpenDetails={onOpenDetails}
                        onTrace={onTrace} isTraced={tracedKey === `${card.id}:${item}`} />
                )} />
            </div>
        </div>
    );
}

function renderPipeCard(card, pos, isExpanded, onToggle, cardStateClass, actions = {}) {
    const { onOpenDetails, onTrace, tracedKey } = actions;

    const isCritical = card.status === 'critical';

    return (
        <div
            key={`card-${card.id}`}
            className={`qd-data-lineage-card card pipe ${isCritical ? 'st-card-critical' : ''} ${cardStateClass}`}
            style={{ left: pos.x, top: pos.y, width: pos.w, height: pos.h, position: 'absolute' }}
        >
            <div className={`qd-data-lineage-card__type-tab c-type-tab c-type-tab--pipe ${isCritical ? 'c-type-tab--critical' : ''}`}>Pipeline</div>
            <div className="c-head">
                <span className="c-ico"><Network size={18} /></span>
                <div className="c-head-info tw-min-w-0 tw-flex-1">
                    <span className="c-name" title={card.name}>{card.name}</span>
                </div>
                {isCritical && (
                    <span className="c-status-badge"><AlertCircle size={12} /> Critical</span>
                )}
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Tasks ({card.tasks.length})</div>
                <ExpandableList items={card.tasks} limit={5} expanded={isExpanded} onToggle={onToggle} renderItem={(item, idx) => (
                    <AttrItem key={idx} icon={<TaskIcon />} text={item} className="c-task task-ok" onOpenDetails={onOpenDetails}
                        onTrace={onTrace} isTraced={tracedKey === `${card.id}:${item}`}
                        isError={!!card.errorRows && card.errorRows.has(item)} />
                )} />
            </div>
            <div className="c-foot"><Rows3 size={12} /> {card.rows} rows · {card.engine}</div>
        </div>
    );
}

function renderDataCard(card, pos, isExpanded, onToggle, cardStateClass, actions = {}) {
    const { onOpenDetails, onTrace, tracedKey } = actions;

    const isCritical = card.status === 'critical';

    return (
        <div
            key={`card-${card.id}`}
            className={`qd-data-lineage-card card data ${isCritical ? 'st-card-critical' : ''} ${cardStateClass}`}
            style={{ left: pos.x, top: pos.y, width: pos.w, height: pos.h, position: 'absolute' }}
        >
            <div className={`qd-data-lineage-card__type-tab c-type-tab c-type-tab--data ${isCritical ? 'c-type-tab--critical' : ''}`}>Dataset</div>
            <div className="c-head">
                <span className="c-ico"><Layers size={18} /></span>
                <div className="c-head-info tw-min-w-0 tw-flex-1">
                    <span className="c-name" title={card.name}>{card.name}</span>
                </div>
                {isCritical && (
                    <span className="c-status-badge"><AlertCircle size={12} /> Critical</span>
                )}
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Attributes ({card.attrs.length})</div>
                <ExpandableList items={card.attrs} limit={5} expanded={isExpanded} onToggle={onToggle} renderItem={(item, idx) => (
                    <AttrItem key={idx} icon={<Tag size={16} />} text={item} onOpenDetails={onOpenDetails}
                        onTrace={onTrace} isTraced={tracedKey === `${card.id}:${item}`}
                        isError={!!card.errorRows && card.errorRows.has(item)} />
                )} />
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Metrics</div>
                <div className="c-item"><span className="fi"><Activity size={16} /></span><span>Row count</span><span className="met">{card.rows}</span></div>
                <div className="c-item"><span className="fi"><Clock size={16} /></span><span>Freshness</span><span className="met">{card.freshness}</span></div>
            </div>
        </div>
    );
}

function renderKpiCard(card, pos, cardStateClass, actions = {}) {
    const { onOpenDetails, onTrace, tracedKey } = actions;

    return (
        <div
            key={`card-${card.id}`}
            className={`qd-data-lineage-card card kpi st-card-success ${cardStateClass}`}
            style={{ left: pos.x, top: pos.y, width: pos.w, height: pos.h, position: 'absolute' }}
        >
            <div className="qd-data-lineage-card__type-tab c-type-tab c-type-tab--kpi">KPI Metric</div>
            <div className="c-head">
                <span className="c-ico"><Gauge size={18} /></span>
                <div className="c-head-info">
                    <span className="c-name" title={card.name}>{card.name}</span>
                </div>
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Mapped attribute</div>
                <AttrItem icon={<Tag size={16} />} text={card.attr} bold onOpenDetails={onOpenDetails}
                    onTrace={onTrace} isTraced={tracedKey === `${card.id}:${card.attr}`} />
            </div>
            <div className="c-sec">
                <div className="c-sec-lbl">Formula</div>
                <div className="c-formula" title={card.formula}>{card.formula}</div>
            </div>
        </div>
    );
}

/* ═══════════════════════════════════════════════
 *  Main component
 * ═══════════════════════════════════════════════ */
export default class WorkflowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedCards: {},
            selectedCardId: null,
            detail: null,
            // `${cardId}:${attrName}` of the row whose connect icon drove the trace
            tracedKey: null
        };
    }

    toggleExpandCard = (cardId) => {
        this.setState(prev => ({
            expandedCards: {
                ...prev.expandedCards,
                [cardId]: !prev.expandedCards[cardId]
            }
        }));
    };

    // Connect icon: trace the lineage of the card this attribute belongs to.
    // Clicking the already-traced row clears the highlight.
    handleTraceAttr = (card, name) => {
        const key = `${card.id}:${name}`;
        this.setState(prev => (
            prev.tracedKey === key
                ? { tracedKey: null, selectedCardId: null }
                : { tracedKey: key, selectedCardId: card.id }
        ));
    };

    // Panel only. Must not touch selectedCardId — the lineage highlight belongs
    // exclusively to the connect icon.
    handleOpenDetails = (card, name) => {
        this.setState({ detail: { card, name } });
    };

    handleCloseDetails = () => this.setState({ detail: null });

    handleJumpToCard = (cardId) => {
        const card = ALL_CARDS.find(c => c.id === cardId);
        if (card) this.setState({ selectedCardId: cardId, detail: null, tracedKey: null });
    };

    render() {
        const { show, onClose, row = {}, data = null, loading = false, error = null } = this.props;
        if (!show) return null;

        if (data != null || loading || error) {
            return (
                <LineageModal
                    show={show}
                    onClose={onClose}
                    row={row}
                    data={data}
                    loading={loading}
                    error={error}
                />
            );
        }

        const kpiName = row.kpiName || 'Total Revenue';
        const { expandedCards, selectedCardId, detail, tracedKey } = this.state;
        const { posMap, canvasW, canvasH } = computeLayout(ALL_CARDS, expandedCards);
        const { connectedNodes, connectedEdges } = getLineageTrace(selectedCardId, EDGE_PAIRS);

        // Tracing from a critical card paints the whole lineage red; anything else blue
        const tracedCard = selectedCardId != null ? ALL_CARDS.find(c => c.id === selectedCardId) : null;
        const criticalTrace = tracedCard?.status === 'critical';
        const activeEdgeColor = criticalTrace ? EDGE_COLOR_CRITICAL : EDGE_COLOR_ACTIVE;
        const activeMarker = criticalTrace ? 'url(#arrow-critical)' : 'url(#arrow-active)';

        const edgeDetails = EDGE_PAIRS
            .filter(([f, t]) => posMap[f] && posMap[t])
            .map(([f, t]) => {
                const key = `${f}-${t}`;
                const isActive = selectedCardId != null && connectedEdges.has(key);
                const isMuted = selectedCardId != null && !isActive;
                const pathD = bezier(posMap[f], posMap[t]);
                return { f, t, key, isActive, isMuted, pathD };
            });

        return (
            <GraphCanvasShell
                show={show}
                onClose={onClose}
                defaultTheme="light"
                autoFit
                canvasW={canvasW}
                canvasH={canvasH}
                cards={ALL_CARDS}
                posMap={posMap}
                title={<><span className="qd-data-lineage-header__prefix k !tw-text-[#64748B] dark:!tw-text-[#94A3B8]"><KpiIcon width={20} height={20} /></span>{' '}{kpiName}</>}
                stats={<WorkflowStats />}
                sidePanel={(
                    <AttrDetailPanel
                        detail={detail}
                        onClose={this.handleCloseDetails}
                        onJumpToCard={this.handleJumpToCard}
                    />
                )}
            >
                {/* SVG Edges */}
                <svg className="lin-edges" viewBox={`0 0 ${canvasW} ${canvasH}`} preserveAspectRatio="none"
                    style={{ width: `${canvasW}px`, height: `${canvasH}px` }}>
                    <defs>
                        {/* Marker fill must equal its line's stroke, or the head reads
                            as a shape detached from the line */}
                        <marker id="arrow-line" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse">
                            <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill={EDGE_COLOR} />
                        </marker>
                        <marker id="arrow-active" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse">
                            <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill={EDGE_COLOR_ACTIVE} />
                        </marker>
                        <marker id="arrow-critical" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse">
                            <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill={EDGE_COLOR_CRITICAL} />
                        </marker>
                    </defs>
                    {edgeDetails
                        .sort((a, b) => (a.isActive ? 1 : 0) - (b.isActive ? 1 : 0))
                        .map((edge) => {
                            const strokeColor = edge.isActive ? activeEdgeColor : EDGE_COLOR;
                            const strokeWidth = edge.isActive ? '2.4px' : '2px';
                            // 0.95 at rest; the traced path goes solid, the rest recedes
                            const opacity = edge.isActive ? 1 : edge.isMuted ? 0.25 : 0.95;
                            const marker = edge.isActive ? activeMarker : 'url(#arrow-line)';

                            return (
                                <path
                                    key={edge.key}
                                    className={edge.isActive ? 'ed-ind' : 'ed-grey'}
                                    d={edge.pathD}
                                    markerEnd={marker}
                                    style={{
                                        stroke: strokeColor,
                                        strokeWidth,
                                        strokeDasharray: 'none',
                                        opacity,
                                        fill: 'none',
                                        transition: 'stroke 0.2s ease, opacity 0.2s ease'
                                    }}
                                />
                            );
                        })}
                </svg>

                {/* Render every card */}
                {ALL_CARDS.map(card => {
                    const p = posMap[card.id];
                    if (!p) return null;
                    const isExp = !!expandedCards[card.id];
                    const onToggle = () => this.toggleExpandCard(card.id);
                    const isSelected = selectedCardId === card.id;
                    const isConnected = selectedCardId != null && connectedNodes.has(card.id);
                    const isMuted = selectedCardId != null && !isConnected;
                    const stateClass = cardStateClasses(isSelected, isConnected, isMuted, criticalTrace);
                    const actions = {
                        onOpenDetails: (name) => this.handleOpenDetails(card, name),
                        onTrace: (name) => this.handleTraceAttr(card, name),
                        tracedKey
                    };

                    switch (card.type) {
                        case 'source': return renderSourceCard(card, p, isExp, onToggle, stateClass, actions);
                        case 'pipe':   return renderPipeCard(card, p, isExp, onToggle, stateClass, actions);
                        case 'data':   return renderDataCard(card, p, isExp, onToggle, stateClass, actions);
                        case 'kpi':    return renderKpiCard(card, p, stateClass, actions);
                        default:       return null;
                    }
                })}
            </GraphCanvasShell>
        );
    }
}
